var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',_vm._l((_vm.items),function(item,index){return _c('b-col',{key:index,staticClass:"mb-3",attrs:{"cols":_vm.cols,"xs":_vm.xs,"sm":_vm.sm,"md":_vm.md,"lg":_vm.lg,"xl":_vm.xl}},[_vm._t("default",null,{"item":item})],2)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }